import type { State } from '../../types';
import type { ConstitutionalDocumentViewModel } from '@trinnvis/dabih-api-client';

import { toList } from '../toList';

export function constitutionalDocumentsNotDeleted(state: State): ConstitutionalDocumentViewModel[] {
  if (state.organization === undefined) return [];
  return toList(state.organization.constitutionalDocumentsById).filter((e) => !e.deleted);
}
